import { createSelector } from '@ngrx/store';
import { AppState } from '../state';
import { WorkPollingState } from './work-polling.state';

export const getWorkPollingState = (appState: AppState): WorkPollingState => appState.workPolling;

export const pollingPaused = createSelector(getWorkPollingState, (state: WorkPollingState): boolean => state.paused);
